import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 6v12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.196 9 6.804 15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6.804 9 10.392 6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Asterisk";
const Asterisk = memo(themed(Icon));
export {
  Asterisk
};
//# sourceMappingURL=asterisk.js.map
